const breakpointSm = window.matchMedia('(max-width: 767px)');
const moveTo = new window.MoveTo({
  duration: 1000,
  easing: 'easeOutQuart',
  tolerance: 100,
});

const initHeaderLinks = () => {
  const triggers = [...document.querySelectorAll('.main-nav__link')];
  if (triggers.length) {
    const breakpointChecker = () => {
      if (!breakpointSm.matches) {
        triggers.forEach((trigger) => {
          moveTo.registerTrigger(trigger);
        });
      } else {
        triggers.forEach((trigger) => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
            let id = trigger.getAttribute('href');
            window.scroll(0, document.querySelector(id).offsetTop - 80);
          });
        });
      }
    };

    breakpointSm.addListener(breakpointChecker);
    breakpointChecker();
  }
};

export default initHeaderLinks;
